import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: boolean
}

export function Card({ padding = true, className, children, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'bg-[var(--bg-primary)] border border-[var(--border)] rounded-xl shadow-[var(--shadow-sm)]',
        padding && 'p-5',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface CardHeaderProps {
  title: string
  description?: string
  icon?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

export function CardHeader({ title, description, icon, actions, className }: CardHeaderProps) {
  return (
    <div className={cn('flex items-start gap-3', className)}>
      {icon && (
        <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[var(--accent-blue-light)] flex items-center justify-center text-[var(--accent-blue)]">
          {icon}
        </div>
      )}
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-[var(--text-primary)] truncate">{title}</h3>
        {description && (
          <p className="text-sm text-[var(--text-secondary)] mt-0.5 line-clamp-2">{description}</p>
        )}
      </div>
      {actions && <div className="flex-shrink-0">{actions}</div>}
    </div>
  )
}
